import * as nodeUtils from "../../abstract/controller/utils/nodeUtils";
import styles from "./ElementTooltipComment.module.scss";

const _regex = /\r?\n|\r|\n/g;

function ElementTooltipComment({ node }) {
  const _comment = nodeUtils.getComment(node);

  return (
    <>
      {_comment && (
        <>
          {_comment.split(_regex).map((e, index) => (
            <div key={index} className={styles["tooltip__line"]}>
              {e}
            </div>
          ))}
        </>
      )}
    </>
  );
}

export default ElementTooltipComment;
